/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from "react";

import { css, jsx } from "@compiled/react";

import Spinner from "@atlaskit/spinner";
import { token } from "@atlaskit/tokens";

const loadingStyles = css({
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "100vh",
    width: "100%"
});

const loadingMessageStyles = css({
    fontSize: "24px",
    marginBlockEnd: token("space.400", "32px")
});

interface LoadingProps {
    message?: string;
}

const Loading: React.FC<LoadingProps> = ({ message = "Loading..." }) => {
    return (
        <div css={loadingStyles}>
            <h3 css={loadingMessageStyles}>{message}</h3>
            <Spinner size="large" />
        </div>
    );
};

export { Loading };
